import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputNumber, SelectValue, changeState } from "./FormControls";

class CalorieCalculatorApp extends React.Component<{}, any> {
	activityOptions = [
		{ text: "Aerobics", value: 0.0992 },
		{ text: "Badminton", value: 0.0970 },
		{ text: "Cricket", value: 0.09 },
		{ text: "Cycling", value: 0.1080 },
		{ text: "Dancing", value: 0.0882 },
		{ text: "Desk Work", value: 0.03 },
		{ text: "Football", value: 0.14 },
		{ text: "Gardening", value: 0.0794 },
		{ text: "Golf", value: 0.06 },
		{ text: "Hiking", value: 0.099 },
		{ text: "Horse Riding", value: 0.082 },
		{ text: "Housework", value: 0.0441 },
		{ text: "Jogging", value: 0.1213 },
		{ text: "Rugby", value: 0.16 },
		{ text: "Running", value: 0.185 },
		{ text: "Squash", value: 0.2 },
		{ text: "Sleeping", value: 0.01 },
		{ text: "Swimming", value: 0.1477 },
		{ text: "Tennis", value: 0.1345 },
		{ text: "Walking", value: 0.08 },
		{ text: "Watching TV", value: 0.015 }
	];
	intensityOptions = [
		{ text: "Average", value: 1.0 },
		{ text: "Recreational", value: 0.55 },
		{ text: "Competitive", value: 1.7 }
	];
	constructor(props) {
		super(props);
		this.state = { weight: 70.0, activity: 0.0992, intensity: 1.0, time: 3600.0 };
	}
	calculateCalories(): number {
		// activity value is kCal/kg/minute
		return (this.state.time/60.0*this.state.activity*this.state.weight*this.state.intensity);
	}
	getEnergyUnits():string {
		return "" + this.calculateCalories().toFixed() + " kCal (" + (this.calculateCalories()*4.18675).toFixed() + " kJ)";
	}
	render() {
		return (
			<div className="app">
				<section>
					<SelectValue options={this.activityOptions} onChange={changeState.bind(this, "activity")} value={this.state.activity} label="Select activity" />
					<SelectValue options={this.intensityOptions} onChange={changeState.bind(this, "intensity")} value={this.state.intensity} label="Intensity (sports activities only)" />
					<InputNumber onChange={changeState.bind(this, "weight")} value={this.state.weight} label="Your weight" property="mass" units="kg" min={0.0} max={1000.0} />
					<InputNumber onChange={changeState.bind(this, "time")} value={this.state.time} label="Enter amount of time" property="time" units="min" min={0.0} max={10000000000.0} />
				</section>
				<section>
					<br />
					<h3>The estimated number of calories burned is: <strong>{this.getEnergyUnits()}</strong></h3>
					<br />
				</section>
			</div>
		);
	}
}

ReactDOM.render(React.createElement(CalorieCalculatorApp, {}), document.getElementById("app"));
